module.exports = __webpack_public_path__ + "img/Steel-Bottle.18fc5242.svg";